import { isError } from 'flux-standard-action';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var PROMISIFY_ACTION = "@@PROMISIFY_ACTION";
function createMiddleware() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$actionType = options.actionType,
      actionType = _options$actionType === void 0 ? PROMISIFY_ACTION : _options$actionType;
  var observers = [];

  var promisifyAction = function promisifyAction(payload) {
    return {
      type: actionType,
      payload: payload
    };
  };

  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (typeof dispatch === "function" && action && action.type === actionType) {
          var payload = action.payload;

          if (!payload) {
            throw new TypeError("Empty payload in action \"".concat(actionType, "\"!"));
          }

          dispatch(payload.action);
          return new Promise(function (resolve, reject) {
            var resolveOn = payload.resolveOn,
                rejectOn = payload.rejectOn;
            observers = _toConsumableArray(observers).concat([{
              resolveOn: resolveOn,
              resolve: resolve,
              rejectOn: rejectOn,
              reject: reject
            }]);
          });
        }

        observers = observers.filter(function (_ref2) {
          var resolveOn = _ref2.resolveOn,
              resolve = _ref2.resolve,
              rejectOn = _ref2.rejectOn,
              reject = _ref2.reject;
          return !(applyFunctionToActionByPredicate(resolve, action, resolveOn) || rejectOn && applyFunctionToActionByPredicate(reject, action, rejectOn));
        });
        return next(action);
      };
    };
  };

  return {
    promisifyAction: promisifyAction,
    middleware: middleware
  };
}

function applyFunctionToActionByPredicate(func, action, predicate) {
  switch (_typeof(predicate)) {
    case "string":
      {
        if (action && action.type === predicate) {
          func(isError(action) ? action.payload : action);
          return true;
        }

        break;
      }

    case "function":
      {
        if (predicate(action)) {
          func(isError(action) ? action.payload : action);
          return true;
        }

        break;
      }

    default:
  }

  return false;
}

var _createMiddleware = createMiddleware(),
    promisifyAction = _createMiddleware.promisifyAction,
    middleware = _createMiddleware.middleware;

export default middleware;
export { PROMISIFY_ACTION, createMiddleware, promisifyAction };
//# sourceMappingURL=redux-promisify-action.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-promisify-action/dist/redux-promisify-action.esm.js
// module id = 395
// module chunks = 124